import type { ButtonHTMLAttributes, ReactNode } from 'react'
import styles from './Button.module.css'

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
    variant?: 'primary' | 'ghost' | 'quiet' | 'danger' | 'chip'
    children: ReactNode
}

export default function Button({ variant = 'ghost', children, className, ...rest }: ButtonProps) {
    return (
        <button type="button" className={`${styles.btn} ${styles[variant]} ${className ?? ''}`} {...rest}>
            {children}
        </button>
    )
}
